import React from 'react';

export default function RemoveSquareIcon({as = React.Fragment, Tag = as, ...props}) {
  return (
    <Tag {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-remove-square"><rect width="18" height="18" x="3" y="3" className="primary" rx="2"/><rect width="12" height="2" x="6" y="11" className="secondary" rx="1"/></svg>
    </Tag>
  )
};
